import Layout from "../Layout";
import PortalLayoutClientWrapper from "./portalLayoutClientWrapper";
import { IClientSession } from "@portal/pages/api/auth/session/types";

export default function PortalLayout({ session, children }: Readonly<{ session: IClientSession; children: React.ReactNode }>) {
  return (
    <PortalLayoutClientWrapper session={session}>
      <Layout session={session}>{children}</Layout>
    </PortalLayoutClientWrapper>
  );
}
